<template>
<div class="columns is-multiline">
  <div v-for="item in choices" :key="item.key" class="column is-6">
    <button @click="chooseAnswer(item)" class="answer-btn button is-primary is-outlined is-rounded is-large is-fullwidth">
      <span class="icon">
        {{item.key}}
      </span>
      <span>
        {{item.choice}}
      </span>
    </button>
  </div>
</div>
</template>

<script>
export default {
  name: 'ub-question-choices',
  props: [
    'question',
  ],
  data() {
    return {
      isBusy: false,
    };
  },
  computed: {
    user() {
      return this.$store.getters['user/dbUser'];
    },
    choices() {
      const keys = Object.keys(this.question.data.choices);
      const choices = [];
      keys.forEach((key) => {
        choices.push({
          key,
          choice: this.question.data.choices[key],
        });
      });
      return choices.sort((a, b) => {
        if(a.key < b.key) { return -1; }
        if(a.key > b.key) { return 1; }
        return 0;
      });
    },
  },
  methods: {
    chooseAnswer(answer) {
      if (this.isBusy) return;
      this.isBusy = true;
      this.$store.dispatch('trivia/answerQuestion', {
        question: this.question,
        user: this.user,
        choice: answer,
      }).then(() => {
        this.isBusy = false;
      }).catch((err) => {
        this.isBusy = false;
        console.error(err);
        throw err;
      });
    },
  },
  mounted() {
  },
  components: {
  },
};
</script>

<style lang="scss" scoped>
.answer-btn{
  justify-content: flex-start;
  .icon{
    font-weight: bold;
  }
}
</style>
